<template>
  <collapse-text :value="displayText" v-bind="$attrs"></collapse-text>
</template>

<script>
import Base from "./view";
import CollapseText from "../collapse-text";

export default {
  extends: Base,

  components: {
    CollapseText,
  },
}
</script>
